import { Box } from '@factorialco/deprecated-design-system'

import { AllFormsDatatable } from './AllFormsDatatable'

export const FormsOverview = ({ trainingId }: { trainingId: number }) => {
  return (
    <Box gap="s32">
      <Box gap="s16">
        <AllFormsDatatable trainingId={trainingId} />
      </Box>
    </Box>
  )
}
